import { values } from 'lodash'

export const MOUNTAIN_SKILL = {
  BAM: 'BAM',
  BASM: 'BASM',
  BCDHM: 'BCDHM',
  BCEHM: 'BCEHM',
  BQTM: 'BQTM',
  BQTM_SUMMER: 'BQTM été',
  BQTM_WINTER: 'BQTM hiver',
  BSM: 'BSM',
  CDHM_SUMMER: 'CDHM été',
  CDHM_WINTER: 'CDHM hiver',
  CEHM_SUMMER: 'CEHM été',
  CEHM_WINTER: 'CEHM hiver',
  GUIDE: 'GUIDE',
  MGM: 'MGM',
  OTHER: 'OTHER',
}

export const QUALIF_SKILL = {
  GHMNumber: 'GHM',
  MGMNumber: 'MGM',
  BCDHMNumber: 'BCDHM',
  CDHM_SUMMERNumber: 'CDHM été',
  CDHM_WINTERNumber: 'CDHM hiver',
  BQTMNumber: 'BQTM',
  SummerQualifNumber: 'Qualif été',
  WinterQualifNumber: 'Qualif hiver',
  CEHMNumber: 'CEHM',
  CEHM_SUMMERNumber: 'CEHM été',
  CEHM_WINTERNumber: 'CEHM hiver',
  BASMNumber: 'BASM',
  BAMNumber: 'BAM',
  BSMNumber: 'BSM',
}

export const MOUNTAIN_SKILL_ARRAY = values(MOUNTAIN_SKILL)
